import {PUSH_ALERT, SET_CONFIG, SET_USER} from '../mutationTypes';

export default {
    // Core-ui
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarOpened ? false : 'responsive'
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, 'responsive'].includes(state.sidebarShow)
        state.sidebarShow = sidebarClosed ? true : 'responsive'
    },
    set(state, [variable, value]) {
        state[variable] = value
    },

    // Custom
    [SET_USER](state, payload) {
        state.user = typeof payload === 'object' && payload !== null ? payload : {};
    },
    [PUSH_ALERT](state, payload) {
        state.alerts.push(payload);
    },
    [SET_CONFIG](state, payload) {
        state.config = payload;
    },
};
